export const INSERT_LAYOUT_BUTTON = 'insert-layout-button';
export const INSERT_LAYOUT_MODAL = 'insert-layout-modal';
export const INSERT_LAYOUT_MODAL_TWO_COLUMNS = 'insert-layout-modal-two-columns';
export const INSERT_LAYOUT_MODAL_THREE_COLUMNS = 'insert-layout-modal-three-columns';

export const LAYOUT_HANDLE = 'layout-handle';
export const PLUGIN_TOOLBAR_DELETE_BUTTON = 'plugin-toolbar-delete-button';

export const LAYOUT_CELL_HANDLE = 'layout-cell-handle';
export const LAYOUT_CELL_TOOLBAR_ADD_LEFT_BUTTON = 'cell-toolbar-button-add-left';
export const LAYOUT_CELL_TOOLBAR_ADD_RIGHT_BUTTON = 'cell-toolbar-button-add-right';
export const LAYOUT_CELL_TOOLBAR_DELETE_BUTTON = 'cell-toolbar-button-delete';
export const LAYOUT_CELL_TOOLBAR_MOVE_LEFT_BUTTON = 'cell-toolbar-button-move-left';
export const LAYOUT_CELL_TOOLBAR_MOVE_RIGHT_BUTTON = 'cell-toolbar-button-move-right';
